var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { defaultTheme } from '@vital-ui/react-theme';
import { superBoxStyle } from '@vital-ui/react-utils';
var Root = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  flex-grow: 1;\n  color: ", ";\n  font-size: 0.93333rem;\n  overflow-x: hidden;\n  ", ";\n"], ["\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  flex-grow: 1;\n  color: ", ";\n  font-size: 0.93333rem;\n  overflow-x: hidden;\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.card.color;
}, superBoxStyle);
Root.defaultProps = {
    theme: defaultTheme,
};
var Content = function (_a) {
    var children = _a.children, style = _a.style, className = _a.className, props = __rest(_a, ["children", "style", "className"]);
    return (React.createElement(Root, __assign({ className: cn('vital__card-content', className), style: style }, props), children));
};
export default Content;
var templateObject_1;
//# sourceMappingURL=Content.js.map